<!-- eslint-disable -->
<template lang="pug">
    school-form(:school='school', :submit='create')
        template(slot='title') {{ $i18n.t('school.school_create_title') }}
        template(slot='button') {{ $i18n.t('school.school_create_button') }}
</template>

<script>
    /*eslint-disable*/
    import SchoolForm from './Form.vue';
    import SchoolApi from '../../api/school'
    export default {
        data() {
            return {
                school: {
                    name: '',
                    status: 'active',
                    email: '',
                    phone: '',
                    courses: [],
                    admins: [],
                    mainContact: null,
                    account: {
                        paymentService: null,
                    },
                    locations: [
                        {
                            city: '',
                            address: '',
                            isMain: true
                        }
                    ],
                    isMapAvailable: true,
                    studentPayed: undefined,
                    isBillingActive: true,
                    isTeachersBillingActive: true,
                }
            }
        },
        components: {
            SchoolForm
        },
        mounted() {
            if (!this.$can('addItem', 'school')) {
                this.$router.push({ name: '403' });
            }
        },
        methods: {
            create(school) {
                return SchoolApi.create(school)
                .then((data) => {
                    this.$router.push({name: 'school:profile', params: {id: data.id, withOpenedBalanceModal: !data.studentPayed && data.isBillingActive}});
                })
            }
        }
    }
</script>
